<template>
  <div class="user-info-main" :class="[showMoreJobMenu?'showMoreJobMenu':'']">
    <div class="top-info">
       <div class="user-picture" :style="{backgroundImage: `url(${personInfo.avatar_url || 'https://files.wondercv.com/pcvue/jobsuser.png'})`}"></div>
       <div class="flex1">
        <a class="my-job-menu" href="/jobs/mailing?tab=1" target="_blank">
          <div class="job-menu-number f_18 color_40">{{jobsCount.application}}</div>
          <div class="job-menu-text f_12 color_9c">已投职位</div>
        </a>
        <a class="my-job-menu" href="/jobs/mailing?tab=2" target="_blank">
          <div class="job-menu-number f_18 color_40">{{jobsCount.favorite}}</div>
          <div class="job-menu-text f_12 color_9c">我的收藏</div>
        </a>
      </div>
      <div class="setting-intention f_14 cursor_p" @click="intentionShow=true" @mouseenter="isShowCard=true;" @mouseleave="hideIntentionCard()">求职意向</div>
    </div>
    <!-- 求职意向 -->
    <div class="intention before" @mouseleave="isShowCard=false;" v-show="isShowCard" @mouseenter="showIntentionCard()" >
      <div class="intention-infos">
        <div class="intention-list">
          <div class="intention-list-title">行业领域：</div>
          <div class="intention-list-info">
            <template v-if="!industrie || !industrie.length">职位不限</template>
            <template v-for="(item,index) in industrie">
              <span :key="item">{{item === '不限' ? '行业不限' : item}}<span v-if="index<industrie.length-1" style="margin-right:5px;">,</span></span>
            </template>
          </div>
        </div>
        <div class="intention-list">
          <div class="intention-list-title">工作地点：</div>
          <div class="intention-list-info">
            <template v-if="!citie || !citie.length">职位不限</template>
            <template v-for="(item,index) in citie">
              <span :key="item">{{item}}<span v-if="index<citie.length-1" style="margin-right:5px;">,</span></span>
            </template>
          </div>
        </div>
        <div class="intention-list">
          <div class="intention-list-title">职位类型：</div>
          <div class="intention-list-info">
            <template v-if="!categorie || !categorie.length">职位不限</template>
            <template v-for="(item, index) in categorie">
              <span :key="item">{{item === '不限' ? '职位不限' : item}}<span v-if="index<categorie.length-1" style="margin-right:5px;">,</span></span>
            </template>
          </div>
        </div>
        <div class="intention-list">
          <div class="intention-list-title">求职状态：</div>
          <div class="intention-list-info">
            <template v-if="userIdentify === 'already_work'">
              职场人{{expectStatus ? `-${expectStatus}` : ''}}
            </template>
            <template v-else-if="userIdentify === 'student'">
              学生党{{expectWorkType.length ? `-${expectWorkType.join(',')}` : ''}}
            </template>
          </div>
        </div>
        <div class="intention-list" v-if="userIdentify === 'already_work' && expect_salary">
          <div class="intention-list-title">期望薪资：</div>
          <div class="intention-list-info">{{expect_salary}}</div>
        </div>
      </div>
      <div class="intention-btn" @click="intentionShow = true" ><span class="iconfont iconedit-"></span> 修改求职意向</div>
    </div>

    <div class="job-menu">
      <div class="job-menu-box pa" @mouseleave="showMoreJobMenu=false;" >
        <template v-for="(level1, level1Index) in professionsData">
          <dl :key="`level1Index`+ level1Index" v-if="showMoreJobMenu || level1Index<5">
            <dd class="pr">
              <div class="level1 color_45 font_15 font_w_b">{{level1.label}}</div>
              <div class="level2-title clearfix">
                <a class="fl f_13 color_60"
                  :href="`/jobs/search?keyword=${level1.label}`" target="_blank"
                  v-for="(level2, level2Index) in level1.list" :key="`level2Index`+ level2Index"
                  >{{level2.label}}</a>
              </div>
              <div class="iconfont iconchevron-right more"></div>
              <div class="more-menu pa" :style="{transform: level1Index=== 13 || level1Index=== 17 ? 'translateY(-50%)' : 'translateY(-20%)'}">
                <div class="level1-title font_15 color_40 font_w_b">{{level1.label}}</div>
                <div class="flex" v-for="(level2,level2Index) in level1.list" :key="'level2Index'+ level2Index">
                  <div class="level2-list-title font_13 color_9c">{{level2.label}}</div>
                  <div class="level3-list font_13 color_60">
                    <div class="level3-list-content">
                      <a class="level3-title"
                        :href="`/jobs/search?keyword=${level3.label}`" target="_blank"
                        v-for="(level3,level3Index) in level2.list" :key="'level3Index'+ level3Index"
                        >{{level3.label}}</a>
                    </div>
                  </div>
                </div>
              </div>
            </dd>
          </dl>
        </template>
      </div>
    </div>
    <div class="job-menu-show color_red f_14 cursor_p" @mouseenter="showMoreJobMenu=true">显示全部职位</div>
   
    <!-- <div class="user-name">
      {{ personInfo.name }}
      <img v-if="!personInfo.is_membership" @click="upVip" src="https://files.wondercv.com/pcvue/jobsuser6.png" alt="">
    </div>
    <div class="line"></div>
    <div class="user-list">
      <div class="user-item" @mousemove="mousemove" @mouseout="mouseout">
        <div class="user-item-img">
          <img src="https://files.wondercv.com/pcvue/jobsuser1.png" alt="">
        </div>
        <div class="user-item-text">求职意向</div>
        <div class="intention before" v-show="isShowCard" @mousemove="mousemove">
          <div class="intention-list text-overflow">
            行业领域：
            <template v-if="!industrie || !industrie.length">职位不限</template>
            <template v-for="item in industrie">
              {{item === '不限' ? '行业不限' : item}}
            </template>
          </div>
          <div class="intention-list text-overflow">
            工作地点：
            <template v-if="!citie || !citie.length">职位不限</template>
            <template v-for="item in citie">
              {{item}}
            </template>
          </div>
          <div class="intention-list text-overflow">
            职位类型：
            <template v-if="!categorie || !categorie.length">职位不限</template>
            <template v-for="item in categorie">
              {{item === '不限' ? '职位不限' : item}}
            </template>
          </div>
          <div class="intention-list text-overflow">
            求职状态：
            <template v-if="userIdentify === 'already_work'">
              职场人{{expectStatus ? `-${expectStatus}` : ''}}
            </template>
            <template v-else-if="userIdentify === 'student'">
              学生党{{expectWorkType.length ? `-${expectWorkType.join(',')}` : ''}}
            </template>
          </div>
          <div class="intention-list text-overflow">
            工作类型：
            {{work_time === '不限' || !work_time ? '全职/实习' : work_time}}
          </div>
          <div class="intention-btn" @click="intentionShow = true">修改</div>
        </div>
      </div>
      <a class="user-item" href="/jobs/mailing?tab=1" target="_blank">
        <div class="user-item-img">
          <img src="https://files.wondercv.com/pcvue/jobsuser2.png" alt="">
        </div>
        <div class="user-item-text">已投职位</div>
      </a>
      <a class="user-item" href="/jobs/mailing?tab=2" target="_blank">
        <div class="user-item-img">
          <img src="https://files.wondercv.com/pcvue/jobsuser3.png" alt="">
        </div>
        <div class="user-item-text">收藏职位</div>
      </a>
      <a class="user-item" href="/jobs/campus/remind" target="_blank" v-if="personInfo.is_student">
        <div class="user-item-img">
          <img src="https://files.wondercv.com/pcvue/jobsuser4.png" alt="">
        </div>
        <div class="user-item-text">网申提醒</div>
      </a>
      <div class="user-item">
        <div class="user-item-img">
          <img src="https://files.wondercv.com/pcvue/jobsuser5.png" alt="">
        </div>
        <div class="user-item-text">名企直投</div>
        <div class="wx before">
          <img src="https://files.wondercv.com/pcvue/mjobs.png" alt="">
        </div>
      </div>
    </div> -->
    <intention :show="intentionShow" @clone="intentionShow = false;" @update="getIntention"/>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import api from '@/api';
import intention from '@/components/jobs/intention';
import conditions from '@/assets/json/conditions';
import {get_tUser} from '@/assets/js/util';

let run = '';
export default {
  components: {
    intention
  },
  props:{
    professionsData:{
      default: ()=>[],
    }
  },
  data() {
    return {
      isShowCard: false,
      intentionShow: false,
      work_time: '',
      userIdentify: null, // 用户身份：学生党或者职场人
      expectStatus: null, // 用户身份是 职场人 时的工作状态 
      expectWorkType: [], // 用户身份是 学生党 时的工作类型
      citie: [],
      categorie: [],
      industrie: [],
      _c_t: null,
      showMoreJobMenu: false,
      jobsCount:{ // 职位数字
        application: 0,
        favorite: 0,
      },
      expect_salary:'', //期望薪资
    };
  },
  computed: {
    ...mapState('me', ['personInfo'])
  },
  async created() {
    this._c_t = get_tUser().c_t || ''
    this.getIntention();
    this.getUserIdentify()
    this.getjobsCount(); // 获取职位数字
    // 获取用户身份
    // let res = await api.cvsV2.getUserStatus();
    // console.log(res);
  },
  methods: {
    upVip() {
      this.$store.dispatch('app/setAlertData', { show: true, type: 'upVip' });
    },
    mousemove() {
      this.isShowCard = true;
      clearTimeout(run);
    },
    mouseout() {
      run = setTimeout(() => {
        this.isShowCard = false;
      }, 300);
    },
    async getUserIdentify () {
      try {
        let res = await api.cvsV2.getIdentifyInfo(this._c_t)
        if (res.code === 1000) {
          this.userIdentify = res.data.status
        }
      } catch (e) {
        console.log(e)
      }

    },
    // 获取求职意向
    async getIntention(options) {
      // let userIntentionsQuery = await dealSignatrue();
      let userIntentions = await api.recruit.jobIntention({"platform": 'pc'});

      this.setIntention(userIntentions.data);
      if (userIntentions.code && userIntentions.code === 1000) {
        await this.$store.dispatch('jobs/getIntention', userIntentions.data);
      }
      // 行业，筛选数据登
      await this.$store.dispatch('jobs/setIntention', conditions);
      if(options && options.reload){
        // 修改身份求职意向时刷新到对应的页面
        if (options.identify === 'student') {
          window.location.href = '/campus_recruiting/user_show'
        } else if (options.identify === 'already_work') {
          window.location.href = '/jobs/recommend'
        } else {
          window.location.reload();
        }
      }
    },
    setIntention(userIntentions = {}) {
      userIntentions = JSON.parse(JSON.stringify(userIntentions));
        this.expect_max_salary = userIntentions.expect_max_salary || '';
        this.expect_min_salary = userIntentions.expect_min_salary || '';
        this.expect_status = userIntentions.expect_status || '';
        // this.isActive();
        // this.industrie = userIntentions.industry_names;
        // this.categorie = userIntentions.profession_names;
        // 求职状态
        this.expectStatus = userIntentions.expect_status
        this.expectWorkType = userIntentions.expect_work_type
        // 工作类型
        if (typeof userIntentions.work_time === 'string') {
          if (userIntentions.work_time === '不限' || userIntentions.work_time === '未开启')
          this.work_time = '不限';
          else
          this.work_time = userIntentions.work_time;
        } else {
          this.work_time = userIntentions.work_time && userIntentions.work_time[0]
        }
        // 城市
        if (typeof userIntentions.cities === 'string') {
          if (!userIntentions.cities) this.citie = ['全国'];
          else if (userIntentions.cities === '未开启') this.citie = ['全国'];
          else this.citie = [userIntentions.cities];
        } else if (!userIntentions.cities || !userIntentions.cities[0]) {
          this.citie = ['全国'];
        } else {
          this.citie = userIntentions.cities || ['全国'];
        }
        if (typeof userIntentions.professions === 'string') {
          if (!userIntentions.professions) this.categorie = ['不限'];
          else if (userIntentions.professions === '未开启') this.categorie = ['不限'];
          else this.categorie = [userIntentions.professions];
        } else {
          this.categorie = userIntentions.professions && userIntentions.professions.length ? userIntentions.professions : ['不限'];
        }

        if (typeof userIntentions.industries === 'string') {
          if (!userIntentions.industries) this.industrie = ['不限'];
          else if (userIntentions.industries === '未开启') this.industrie = ['不限'];
          else this.industrie = [userIntentions.industries];
        } else {
          this.industrie = userIntentions.industries && userIntentions.industries.length ? userIntentions.industries : ['不限'];
        }
        if(typeof userIntentions.expect_min_salary === 'string' && typeof userIntentions.expect_max_salary === 'string'){
          this.expect_salary = userIntentions.expect_min_salary + '-' + userIntentions.expect_max_salary + 'k'
        }
    },
    // 获取职位数字
    getjobsCount(){
      let allQuery = [
        api.jobs.getFavoriteList({page:1,page_size:10}),
        api.jobs.getApplicationList({page:1,page_size:10}),
      ]
      Promise.all(allQuery).then(allRes=>{
        if(allRes[0].code === 1000){
          this.jobsCount.favorite = allRes[0].data.favorite_job_count;
        }
        if(allRes[1].code === 1000){
          this.jobsCount.application = allRes[1].data.application_job_count;
        }
      })
    },
    // 延迟显示
    hideIntentionCard(){
      this.isShowCard=false;
    },
    showIntentionCard(){
      this.isShowCard=true;
      setTimeout(() => {
        this.isShowCard=true;
      }, 10);
    },
  },
}
</script>
<style lang="scss" scoped>
  @import './userInfo.scss'
</style>
